import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import HeaderNewClear from '../partials/HeaderNewClear.jsx'
import FooterNew from '../partials/FooterNew.jsx'
import initializers from '../../dependencies/initializers.js'



import imgHero from '../../images/hero_img_internal_mobility.png'
import imgSectionOne from '../../images/img_internal_mobility_01.png'
import imgSectionTwo from '../../images/img_internal_mobility_02.png'
import imgSectionThree from '../../images/img_internal_mobility_03.png'
import imgRoundedLeftTop from '../../images/rounded_left_top.png'

import { accesslog, translate } from '../../helpers/global.js'

import { usersGetDetailAsync } from '../../actions/users.js'
import { getWeeklyDemoDataAsync } from '../../actions/global';
class InternalMobility extends React.Component {
	constructor(props) {
		super(props)
	}

	async componentDidMount() {
		window.scrollTo(0, 0)
		if (!this.props.weeklyDemoData || !this.props.weeklyDemoData.webinar_link) {
			await this.props.getWeeklyDemoDataAsync();
		}
	}

  chooseOpt(val) {
		const url_api = initializers.api_host
		  if(val === '1') {
			  if (process.env.NODE_ENV === 'development') {
				window.location = 'http://localhost:3000/'
			} else if (url_api == 'https://beta.astrnt.co') {
	
				window.location = 'https://test.astrnt.co/'
	
			} else {
				window.location = 'https://astrnt.co/'
			}
		  } else {
			  if (process.env.NODE_ENV === 'development') {
				window.location = 'http://localhost:3000/'
			} else if (url_api == 'https://beta.astrnt.co') {
	
				window.location = 'https://test.astrnt.id/'
	
			} else {
				window.location = 'https://astrnt.id/'
			}
		  }
		}

  render() {
    const {
      globalGetLanguages,
      user, weeklyDemoData
    } = this.props
    const renderHTML = (rawHTML: string) => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });
    return (
			<div id="homepage">
        <HeaderNewClear isOnStatusFor="is-on" />
        <div className="banner ai">
          <section>
            <div className="ban-text apis">
              <div className="title-1">Supporting Internal</div>
              <div className="title-1">Mobility with Structure</div>
              <div className="title-1">and Insight</div>
              

              <p className='sub-title-1' style={{ marginTop: '20px' }}>
                  Make Smarter Moves with the Talent You Already Have
                </p>

              <div className='content-desc-technical'>
                Promotions and transfers happen every day. But without structure, internal mobility can be inconsistent or based on limited visibility. ASTRNT helps bring clarity into internal moves, so leaders can make better decisions and employees can grow in the right direction.
              </div>

              <div className={`ban-link`}>
                <Link onClick={() => {
                  document.getElementById('modal_talk_expert').classList.add('show-cta-modal');
                  accesslog('talent-management/internal-mobility', 'button_talk_to_an_expert');
                }} className="try">{translate(globalGetLanguages,'BUTTON_TALK_EXPERT')}</Link>
                <a href={weeklyDemoData.webinar_link} target="_blank" className={`request-demo-logged${weeklyDemoData.webinar_link != null ? '' : ' hide'}`}
                  onClick={() => accesslog('talent-management/internal-mobility', 'button_register_for_demo')}
                >Register for Demo</a>
              </div>
              <div className={`ban-link hide`}>
                <Link onClick={() => document.getElementById('modal_talk_expert').classList.add('show-cta-modal')}  className='try'>{translate(globalGetLanguages,'BUTTON_TALK_EXPERT')}</Link>
              </div>
              <a href="#" className="vid-msg">
                <img src={imgHero} />
              </a>
            </div>
          </section>
        </div>


     <div className="section-white" style={{position: 'relative', overflow: 'hidden'}}>
          <a href="#" className="vid-msg-left-top">
            <img src={imgRoundedLeftTop} />
          </a>

          <section className='flex-container position-relative'>
            <div className='flex-item-left'>
              <div className='vertical-item--center' style={{ margin: '0 70px 0 0' }}>
                <img className='img-100' src={imgSectionOne}  />
              </div>
            </div>
            
            <div className='flex-item-right'>
              <div className='vertical-item--center'>
                <div className='sec-desc-point'>
                  <h2 className='m-t-0 m-b-24' style={{ fontWeight: '700' }}>
                    Why Internal Moves Are Often <br />Missed Opportunities
                  </h2>
                  <p className='m-b-24'>
                    Many companies want to grow from within, but internal mobility is often driven by assumptions or informal referrals. Without consistent evaluation, good people get overlooked—or moved into roles that don’t fit.
                  </p>
                  <p className='m-b-8'>Common challenges:</p>
                  <ul>
                    <li><i className="fas fa-check" />No structured way to compare internal candidates</li>
                    <li><i className="fas fa-check" />Managers only promote people they know</li>
                    <li><i className="fas fa-check" />Employees feel stuck or unsure how to move forward</li>
                    <li><i className="fas fa-check" />HR lacks visibility into readiness or potential</li>
                    <li><i className="fas fa-check" />Talent is moved without understanding fit or gaps</li>
                  </ul>
                 
                </div>
              </div>
            </div> 
          </section>
      </div>
    
    <div className="section-white" style={{position: 'relative', overflow: 'hidden'}}>
          <section className='flex-container'>
            <div className='flex-item-right'>
              <div className='vertical-item--center'>
                <div className='sec-desc'>

                  <h2 className='m-t-0 m-b-24' style={{ fontWeight: '700' }}>
                    Internal Mobility Needs More Than an Open Role

                  </h2>
                  <p className='m-b-24'>
                    Moving people into new roles isn’t just about availability. It’s about capability, readiness, and fit. Structured assessments and interviews help reveal strengths, leadership signals, and development areas—so internal candidates are placed where they can truly thrive.
                  </p>
                  <p className='m-b-8'>What companies usually assess before internal moves:</p>                  
                  <ul>
                    <li><i className="fas fa-check" />Communication and decision making</li>
                    <li><i className="fas fa-check" />Strategic or operational thinking</li>
                    <li><i className="fas fa-check" />Role readiness based on level or function</li>
                    <li><i className="fas fa-check" />Alignment with team or business culture</li>
                    <li><i className="fas fa-check" />Learning agility or growth mindset</li>
                  </ul>
                </div>
              </div>
            </div> 

            <div className='flex-item-left'>
              <div className='vertical-item--center'>
                <img className='img-100' src={imgSectionTwo} />
              </div>
            </div>
          
          </section>
    </div>


    <div className="section-white" style={{position: 'relative', overflow: 'hidden'}}>
          <section className='flex-container'>

            <div className='flex-item-left'>
              <div className='vertical-item--center'>
                <img className='img-80' src={imgSectionThree} />
              </div>
            </div>

            <div className='flex-item-right'>
              <div className='vertical-item--center'>
                <div className='sec-desc'>

                  <h2 className='m-t-0 m-b-24' style={{ fontWeight: '700' }}>
                    Supporting All Your Key Decisions
                  </h2>
                  <ul>
                    <li><i className="fas fa-check" />Identifying team leads among high-performing staff</li>
                    <li><i className="fas fa-check" />Supporting cross-functional transfers between divisions</li>
                    <li><i className="fas fa-check" />Shortlisting candidates for promotion programs</li>
                    <li><i className="fas fa-check" />Building internal pipelines for critical roles</li>
                    <li><i className="fas fa-check" />Making rotation programs more structured and <br />objective</li>
                  </ul>

                </div>
              </div>
            </div>           
          </section>
    </div>


      <div className="section-gray single-triangle triangle-right" style={{position: 'relative'}}>
          <section className='p-t-50 p-b-50'>
            <div className='ai-interview-start'>
              <h1>Unlock the Potential Already <br />Inside Your Teams</h1>
              <h4>Internal mobility works best when supported by clear data, consistent evaluation, and <br />structured conversations. ASTRNT helps you support growth without guesswork.</h4>
                <div className="ban-text-start-demo">
                <div className={`ban-link`}>
                  <a onClick={() => {
                    document.getElementById('modal_talk_expert').classList.add('show-cta-modal');
                    accesslog('talent-management/internal-mobility', 'button_talk_to_an_expert');
                  }} className="try">{translate(globalGetLanguages,'BUTTON_TALK_EXPERT')}</a>
                  <a href={weeklyDemoData.webinar_link} target="_blank" className={`request-demo-logged${weeklyDemoData.webinar_link != null ? '' : ' hide'}`}
                    onClick={() => accesslog('talent-management/internal-mobility', 'button_register_for_demo')}
                  >Register for Demo</a>
                </div>
              </div>

            </div>
          </section>
      </div>

        
        <FooterNew />
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
	return {
    globalGetLanguages:state.globalGetLanguages,
    user: state.user,
    weeklyDemoData: state.weeklyDemo.weeklyDemoData
	}
}

const mapDispatchToProps = (dispatch) => {
  return {
    usersGetDetailAsync: (user) => dispatch(usersGetDetailAsync(user)),
    getWeeklyDemoDataAsync: () => dispatch(getWeeklyDemoDataAsync())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(InternalMobility)
